import { useState } from 'react'
import { styled } from 'baseui'
import { lightTheme } from '@/customTheme'

/** 'quiet': no fill until picked, then light grey with title text (Batch phone tags). */
export type CategoryButtonVariant = 'default' | 'bordered' | 'quiet'

interface CategoryButtonProps {
  label: string
  isActive: boolean
  onClick: () => void
  disabled?: boolean
  variant?: CategoryButtonVariant
}

const StyledButton = styled(
  'button',
  ({ $isActive, $variant }: { $isActive: boolean; $variant: CategoryButtonVariant }) => {
    const bordered = $variant === 'bordered'
    if ($variant === 'quiet') {
      return {
        height: '28px',
        padding: '0 12px',
        borderRadius: '100px',
        border: 'none',
        backgroundColor: $isActive ? lightTheme.colors.grayScale100 : 'transparent',
        ...lightTheme.typography.Small12medium,
        fontWeight: $isActive ? 600 : 500,
        lineHeight: '16px',
        color: $isActive ? lightTheme.colors.blackGray : lightTheme.colors.grayScale600,
        whiteSpace: 'nowrap' as const,
        cursor: 'pointer',
        outline: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }
    }
    return {
      padding: bordered ? '8px 18px' : '2px 12px',
      borderRadius: bordered ? '18px' : '100px',
      border: bordered
        ? `1px solid ${$isActive ? lightTheme.colors.blackGray : lightTheme.colors.grayScale100}`
        : 'none',
      backgroundColor: $isActive
        ? lightTheme.colors.blackGray
        : bordered
        ? 'transparent'
        : lightTheme.colors.grayScale50,
      ...lightTheme.typography.Small12medium,
      lineHeight: bordered ? '16px' : lightTheme.typography.Small12medium.lineHeight,
      color: $isActive ? lightTheme.colors.white : lightTheme.colors.blackGray,
      whiteSpace: 'nowrap' as const,
      cursor: 'pointer',
      outline: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      ':hover': {
        background: $isActive ? {} : lightTheme.colors.grayScale100,
      },
    }
  }
)

function CategoryButton({ label, isActive, onClick, disabled, variant = 'default' }: CategoryButtonProps) {
  return (
    <StyledButton
      $isActive={isActive}
      $variant={variant}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </StyledButton>
  )
}

export default CategoryButton
